/**
 * @generated SignedSource<<fa1391d401709280958b7e53f1666cd1>>
 * @relayHash 78d13f0d1fdc6880857606f82d2074ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0

import type { ConcreteRequest } from 'relay-runtime';
export type collectionChangePlanPopupQuery$variables = {
  collectionEntitlementId: string;
};
export type collectionChangePlanPopupQuery$data = {
  readonly ccp: {
    readonly entitlementV2: {
      readonly experienceCapabilities: {
        readonly manageEntitlement: {
          readonly experienceUrl: string | null | undefined;
          readonly isAvailableToUser: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type collectionChangePlanPopupQuery = {
  response: collectionChangePlanPopupQuery$data;
  variables: collectionChangePlanPopupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionEntitlementId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "collectionEntitlementId"
  }
],
v2 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpManageEntitlementExperienceCapability",
      "kind": "LinkedField",
      "name": "manageEntitlement",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "experienceUrl"
        },
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "collectionChangePlanPopupQuery",
    "selections": [
      {
        "concreteType": "CcpQueryApi",
        "kind": "LinkedField",
        "name": "ccp",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "CcpEntitlement",
            "kind": "LinkedField",
            "name": "entitlementV2",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "collectionChangePlanPopupQuery",
    "selections": [
      {
        "concreteType": "CcpQueryApi",
        "kind": "LinkedField",
        "name": "ccp",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "CcpEntitlement",
            "kind": "LinkedField",
            "name": "entitlementV2",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0",
    "metadata": {},
    "name": "collectionChangePlanPopupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9b656bb88394dc31aa1596f9938d5c9a";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
